export default "__VITE_ASSET__CtI1xvzO__"